import styled from 'styled-components';

const Grid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 1rem;
  align-self: start;
  > * {
    min-width: 0;
  }
`;

export default Grid;
